
export const headerData = {
    name: 'ANDRES TORRES',
    lastname: 'SANDOVAL',
    description: "Frontend Developer & Business Management",
}
